<div class="min-h-screen py-8 px-4 sm:px-6 lg:px-8">
    <div class="max-w-7xl mx-auto">
        <!-- Titre de la page  -->
        <h1 class="text-3xl font-bold text-gray-900 mb-8">{{ t('compte.title') }}</h1>

        <div class="grid grid-cols-1 lg:grid-cols-12 gap-6">
            <!-- Carte du profil utilisateur (gauche) -->
            <div class="lg:col-span-4">
                <div class="bg-white rounded-lg shadow-sm p-8">
                    <!-- Photo de profil ou icône par défaut -->
                    <div class="flex justify-center mb-6">
                        <div class="relative">
                            <img [src]="getUserPhotoUrl()" (error)="onPhotoError()" (load)="resetPhotoError()"
                                alt="Photo de profil"
                                class="w-32 h-32 rounded-full object-cover border-4 border-[#ff5c01] shadow-md" />

                            <!-- Input caché pour la sélection de fichier -->
                            <input type="file" id="photoInput" accept="image/*" (change)="onPhotoSelected($event)"
                                class="hidden" />

                            <!-- Bouton de modification de photo -->
                            <button type="button" (click)="triggerPhotoInput()" [disabled]="isUploadingPhoto()"
                                class="absolute bottom-0 right-0 bg-gray-600 hover:bg-gray-700 text-white rounded-full p-2 shadow-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                                [title]="t('compte.photo.reminder')">
                                @if (isUploadingPhoto()) {
                                <svg class="animate-spin w-5 h-5" fill="none" viewBox="0 0 24 24">
                                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor"
                                        stroke-width="4"></circle>
                                    <path class="opacity-75" fill="currentColor"
                                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                                    </path>
                                </svg>
                                } @else {
                                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z">
                                    </path>
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M15 13a3 3 0 11-6 0 3 3 0 016 0z"></path>
                                </svg>
                                }
                            </button>
                        </div>
                    </div>

                    <!-- Message d'info pour nouvelle photo -->
                    @if (selectedPhotoFile()) {
                    <div
                        class="mb-4 p-3 bg-gradient-to-r from-blue-50 to-indigo-50 border-l-4 border-blue-500 rounded-lg">
                        <div class="flex items-center gap-3">
                            <svg class="w-5 h-5 text-blue-600 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                                <path fill-rule="evenodd"
                                    d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                                    clip-rule="evenodd" />
                            </svg>
                            <div class="flex-1">
                                <p class="text-sm font-medium text-blue-800">
                                    📸 {{ selectedPhotoFile()!.name }}
                                </p>
                                <p class="text-xs text-blue-700 mt-0.5">
                                    Cliquez sur "Mettre à jour" pour enregistrer
                                </p>
                            </div>
                        </div>
                    </div>
                    }

                    <!-- Nom et profil -->
                    <div class="text-center">
                        <h2 class="text-2xl font-bold text-gray-900 mb-1">
                            {{ getUserFullName() }}
                        </h2>
                        <p class="text-gray-600 text-sm">{{ getUserProfile() }}</p>
                    </div>
                </div>
            </div>


            <!-- Contenu principal (droite) -->
            <div class="lg:col-span-8">
                <div class="bg-white rounded-lg shadow-sm">
                    <!-- Onglets -->
                    <div class="border-b border-gray-200 px-8 pt-6">
                        <nav class="flex space-x-8" aria-label="Tabs">
                            <button type="button" (click)="setActiveTab('informations')" [class]="activeTab() === 'informations' 
            ? 'border-[#ff5c01] text-[#ff5c01] font-medium' 
            : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'"
                                class="py-4 px-1 border-b-2 text-sm transition-colors">
                                {{ t('compte.tabs.info') }}
                            </button>

                            @if (!isAdmin()) {
                            <button type="button" (click)="setActiveTab('abonnements')" [class]="activeTab() === 'abonnements' 
            ? 'border-[#ff5c01] text-[#ff5c01] font-medium' 
            : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'"
                                class="py-4 px-1 border-b-2 text-sm transition-colors">
                                {{ t('compte.tabs.subscriptions') }}
                            </button>
                            <button type="button" (click)="setActiveTab('factures')" [class]="activeTab() === 'factures' 
            ? 'border-[#ff5c01] text-[#ff5c01] font-medium' 
            : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'"
                                class="py-4 px-1 border-b-2 text-sm transition-colors">
                                {{ t('compte.tabs.invoices') }}
                            </button>
                            }
                        </nav>
                    </div>

                    <!-- Contenu de l'onglet -->
                    <div class="p-8">
                        <!-- Section Informations personnelles -->
                        @if (activeTab() === 'informations') {
                        <form [formGroup]="userForm" (ngSubmit)="onSubmit()">
                            <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                                <!-- Prénom -->
                                <div>
                                    <label for="prenom" class="block text-sm font-medium text-gray-700 mb-2">
                                        {{ t('compte.form.firstName') }} <span class="text-red-500">*</span>
                                    </label>
                                    <input type="text" id="prenom" formControlName="prenom"
                                        [class.border-red-500]="isFieldInvalid('prenom')"
                                        [class.border-gray-300]="!isFieldInvalid('prenom')"
                                        class="w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-[#ff5c01] focus:border-transparent transition-colors"
                                        placeholder="Ex: Cheikh" />
                                    @if (isFieldInvalid('prenom')) {
                                    <p class="mt-1 text-sm text-red-600 flex items-center gap-1">
                                        <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                                            <path fill-rule="evenodd"
                                                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                                                clip-rule="evenodd" />
                                        </svg>
                                        {{ getFieldError('prenom') }}
                                    </p>
                                    }
                                </div>

                                <!-- Nom -->
                                <div>
                                    <label for="nom" class="block text-sm font-medium text-gray-700 mb-2">
                                        {{ t('compte.form.lastName') }} <span class="text-red-500">*</span>
                                    </label>
                                    <input type="text" id="nom" formControlName="nom"
                                        [class.border-red-500]="isFieldInvalid('nom')"
                                        [class.border-gray-300]="!isFieldInvalid('nom')"
                                        class="w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-[#ff5c01] focus:border-transparent transition-colors"
                                        placeholder="Ex: Gueye" />
                                    @if (isFieldInvalid('nom')) {
                                    <p class="mt-1 text-sm text-red-600 flex items-center gap-1">
                                        <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                                            <path fill-rule="evenodd"
                                                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                                                clip-rule="evenodd" />
                                        </svg>
                                        {{ getFieldError('nom') }}
                                    </p>
                                    }
                                </div>

                                <!-- Numéro de téléphone -->
                                <div>
                                    <label for="telephone" class="block text-sm font-medium text-gray-700 mb-2">
                                        {{ t('compte.form.phone') }} <span class="text-red-500">*</span>
                                    </label>
                                    <div class="relative">
                                        <span class="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500">
                                            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                    d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                                            </svg>
                                        </span>
                                        <input type="tel" id="telephone" formControlName="telephone"
                                            [class.border-red-500]="isFieldInvalid('telephone')"
                                            [class.border-gray-300]="!isFieldInvalid('telephone')"
                                            class="w-full pl-10 pr-4 py-3 border rounded-lg focus:ring-2 focus:ring-[#ff5c01] focus:border-transparent transition-colors"
                                            placeholder="Ex: 78 183 73 70" />
                                    </div>
                                    @if (isFieldInvalid('telephone')) {
                                    <p class="mt-1 text-sm text-red-600 flex items-center gap-1">
                                        <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                                            <path fill-rule="evenodd"
                                                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                                                clip-rule="evenodd" />
                                        </svg>
                                        {{ getFieldError('telephone') }}
                                    </p>
                                    }
                                </div>

                                <!-- Email -->
                                <div>
                                    <label for="email" class="block text-sm font-medium text-gray-700 mb-2">
                                        {{ t('compte.form.email') }} <span class="text-red-500">*</span>
                                    </label>
                                    <div class="relative">
                                        <span class="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500">
                                            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                    d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                                            </svg>
                                        </span>
                                        <input type="email" id="email" formControlName="email"
                                            [class.border-red-500]="isFieldInvalid('email')"
                                            [class.border-gray-300]="!isFieldInvalid('email')"
                                            class="w-full pl-10 pr-4 py-3 border rounded-lg focus:ring-2 focus:ring-[#ff5c01] focus:border-transparent transition-colors"
                                            placeholder="Ex: cgueye@gmail.com" />
                                    </div>
                                    @if (isFieldInvalid('email')) {
                                    <p class="mt-1 text-sm text-red-600 flex items-center gap-1">
                                        <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                                            <path fill-rule="evenodd"
                                                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                                                clip-rule="evenodd" />
                                        </svg>
                                        {{ getFieldError('email') }}
                                    </p>
                                    }
                                </div>

                                <!-- Adresse -->
                                <div>
                                    <label for="adress" class="block text-sm font-medium text-gray-700 mb-2">
                                        {{ t('compte.form.address') }}
                                    </label>
                                    <div class="relative">
                                        <span class="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500">
                                            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                    d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                    d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                                            </svg>
                                        </span>
                                        <input type="text" id="adress" formControlName="adress"
                                            class="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#ff5c01] focus:border-transparent transition-colors"
                                            placeholder="Ex: 123 Rue Example, Dakar" />
                                    </div>
                                </div>

                                <!-- Nom de l'entreprise -->
                                <div>
                                    <label for="company" class="block text-sm font-medium text-gray-700 mb-2">
                                        {{ t('compte.form.company') }}
                                    </label>
                                    <div class="relative">
                                        <span class="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500">
                                            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                    d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                                            </svg>
                                        </span>
                                        <input type="text" id="company" formControlName="company"
                                            class="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#ff5c01] focus:border-transparent transition-colors"
                                            placeholder="Ex: Entreprise A" />
                                    </div>
                                </div>

                                <!-- Profil (lecture seule) -->
                                <div class="md:col-span-2">
                                    <label for="profil" class="block text-sm font-medium text-gray-700 mb-2">
                                        {{ t('compte.form.profile') }}
                                    </label>
                                    <div class="relative">
                                        <span class="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500">
                                            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                    d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                                            </svg>
                                        </span>
                                        <input type="text" id="profil" [value]="getUserProfile()" readonly
                                            class="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg bg-gray-50 text-gray-600 cursor-not-allowed" />
                                        <span class="absolute right-3 top-1/2 -translate-y-1/2">
                                            <svg class="w-5 h-5 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                                                <path fill-rule="evenodd"
                                                    d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
                                                    clip-rule="evenodd" />
                                            </svg>
                                        </span>
                                    </div>
                                    <p class="mt-1 text-xs text-gray-500">{{ t('compte.profile.cantEdit') }}</p>
                                </div>
                            </div>

                            <!-- Message de changement de photo en attente -->
                            @if (selectedPhotoFile()) {
                            <div
                                class="mt-6 p-4 bg-gradient-to-r from-blue-50 to-indigo-50 border-l-4 border-blue-500 rounded-lg">
                                <div class="flex items-start gap-3">
                                    <svg class="w-5 h-5 text-blue-600 mt-0.5 flex-shrink-0" fill="currentColor"
                                        viewBox="0 0 20 20">
                                        <path fill-rule="evenodd"
                                            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                                            clip-rule="evenodd" />
                                    </svg>
                                    <div class="flex-1">
                                        <p class="text-sm font-medium text-blue-800">
                                            <!-- 📸 {{ t('compte.photo.newDetails') }} : {{ selectedPhotoFile()!.name }} -->
                                        </p>
                                        <p class="text-xs text-blue-700 mt-1">
                                            {{ t('compte.photo.reminder') }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            }



                            <!-- Boutons d'action -->
                            <div class="flex items-center justify-end gap-4 mt-8 pt-6 border-t border-gray-200">
                                <button type="button" (click)="onCancel()" [disabled]="isSaving()"
                                    class="px-6 py-3 text-gray-700 font-medium hover:bg-gray-100 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed border border-gray-300">
                                    <span class="flex items-center gap-2">
                                        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                d="M6 18L18 6M6 6l12 12" />
                                        </svg>
                                        {{ t('common.cancel') }}
                                    </span>
                                </button>
                                <button type="submit"
                                    [disabled]="(userForm.invalid && !selectedPhotoFile()) || isSaving() || (!userForm.dirty && !selectedPhotoFile())"
                                    class="px-8 py-3 bg-[#ff5c01] hover:bg-[#e54f00] text-white font-medium rounded-lg shadow-sm transition-all disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2 hover:shadow-md">
                                    @if (isSaving()) {
                                    <svg class="animate-spin h-5 w-5 text-white" fill="none" viewBox="0 0 24 24">
                                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor"
                                            stroke-width="4"></circle>
                                        <path class="opacity-75" fill="currentColor"
                                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                                        </path>
                                    </svg>
                                    <span>{{ t('common.saving') }}...</span>
                                    } @else {
                                    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M5 13l4 4L19 7" />
                                    </svg>
                                    <span>{{ t('common.update') }}</span>
                                    }
                                </button>
                            </div>
                        </form>
                        }

              @if (activeTab() === 'abonnements') {
<div>
    @if (isCheckingSubscription()) {
    <!-- Chargement de la vérification -->
    <div class="flex justify-center items-center py-12">
        <svg class="animate-spin h-8 w-8 text-[#ff5c01]" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor"
                stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
            </path>
        </svg>
    </div>
    } @else {
        @if (hasActiveSubscription()) {
        <!-- Affichage de l'abonnement en cours -->
        <div class="space-y-6">
            <!-- En-tête avec badge actif -->
            <div class="bg-gradient-to-r bg-gray-100 rounded-xl p-6 text-white">
                <div class="flex items-center justify-between">
                    <div class="flex items-center gap-4">
                        <div class="w-16 h-16 bg-[#ff5c01] rounded-full flex items-center justify-center">
                            <svg width="28" height="28" viewBox="0 0 24 24" fill="white"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M19.0006 18.8823H5.00003C4.44773 18.8823 4 19.3564 4 19.9412C4 20.526 4.44773 21 5.00003 21H19.0006C19.5529 21 20.0006 20.526 20.0006 19.9412C20.0006 19.3564 19.5529 18.8823 19.0006 18.8823Z" />
                                <path
                                    d="M20.9938 6.29224L19.9957 15.8221C19.9382 16.3588 19.511 16.7641 18.9998 16.7641H5.00012C4.49112 16.7641 4.06179 16.3588 4.00647 15.8221L3.00617 6.29224C2.9619 5.8728 3.15887 5.46508 3.5041 5.25653C3.85155 5.04798 4.28088 5.0761 4.59956 5.32917L7.82618 7.89032L11.2188 3.39601C11.4091 3.14528 11.6968 3 12 3C12.3054 3 12.5909 3.14528 12.7812 3.39601L16.176 7.89032L19.4004 5.32917C19.7191 5.0761 20.1506 5.04798 20.4959 5.25653C20.8433 5.46508 21.038 5.8728 20.9938 6.29224Z" />
                            </svg>
                        </div>

                        <div>
                            <h3 class="text-xl font-bold  text-black/90 ">{{ t('compte.subscription.title') }}</h3>
                            <p class="text-black/60 mt-1">{{ t('compte.subscription.expire') }} : {{ getExpirationDate() }}</p>
                        </div>
                    </div>
                    <span class="bg-gray-200 text-green-500 px-4 py-2 rounded-full text-sm font-semibold">
                        {{ t('common.active') }}
                    </span>
                </div>
            </div>

            <!-- Détails de l'abonnement -->
            @if (currentSubscription()) {
            <div class="bg-white border-2 border-gray-100 rounded-xl p-8">
                <h4 class="text-xl font-bold text-gray-900 mb-6">{{ t('compte.subscription.details') }}</h4>

                <div class="space-y-4">
                    <!-- Nom du plan -->
                    <div class="flex justify-between items-center py-3 border-b border-gray-100">
                        <span class="text-gray-600">{{ t('compte.subscription.planName') }}</span>
                        <span class="text-gray-900 font-semibold">{{ getCurrentPlanName() }}</span>
                    </div>

                    <!-- Sous-titre -->
                    <div class="flex justify-between items-center py-3 border-b border-gray-100">
                        <span class="text-gray-600">{{ t('compte.subscription.subtitle') }}</span>
                        <span class="text-gray-900 font-bold">{{ getCurrentPlanLabel() }}</span>
                    </div>

                    <!-- Statut paiement -->
                    <div class="flex justify-between items-center py-3 border-b border-gray-100">
                        <span class="text-gray-600">{{ t('compte.subscription.paymentStatus') }}</span>
                        <span class="inline-flex items-center gap-2">
                            <span class="w-2 h-2 bg-green-500 rounded-full"></span>
                            <span class="text-green-600 font-semibold">{{ t('common.paid') }}</span>
                        </span>
                    </div>

                    <!-- Période -->
                    <div class="flex justify-between items-center py-3 border-b border-gray-100">
                        <span class="text-gray-600">{{ t('compte.subscription.period') }}</span>
                        <span class="text-gray-900 font-medium">{{ getSubscriptionPeriod() }}</span>
                    </div>

                    <!-- Montant payé -->
                    <div class="flex justify-between items-center py-3 border-b border-gray-100">
                        <span class="text-gray-600">{{ t('compte.subscription.amountPaid') }}</span>
                        <span class="text-gray-900 font-bold text-lg">{{ getCurrentPlanAmount() }}</span>
                    </div>

                    <!-- Avantages -->
                    <div class="mt-8 p-6 bg-gray-50 rounded-lg">
                        <h5 class="font-semibold text-gray-900 mb-4">{{ t('compte.subscription.includedBenefits') }}</h5>
                        <ul class="space-y-3">
                            <li class="flex items-start gap-3">
                                <svg class="w-5 h-5 text-[#ff5c01] mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                                    <path fill-rule="evenodd"
                                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                                        clip-rule="evenodd" />
                                </svg>
                                <span class="text-gray-700">
                                    @if (isUnlimitedProjects()) {
                                    {{ t('compte.subscription.unlimitedProjects') }}
                                    } @else {
                                    {{ t('compte.subscription.maxProjects', {limit: getProjectLimit()}) }}
                                    }
                                </span>
                            </li>
                            <li class="flex items-start gap-3">
                                <svg class="w-5 h-5 text-[#ff5c01] mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                                    <path fill-rule="evenodd"
                                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                                        clip-rule="evenodd" />
                                </svg>
                                <span class="text-gray-700">MOA, BET, Chef & Ouvrier</span>
                            </li>
                            <li class="flex items-start gap-3">
                                <svg class="w-5 h-5 text-[#ff5c01] mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                                    <path fill-rule="evenodd"
                                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                                        clip-rule="evenodd" />
                                </svg>
                                <span class="text-gray-700">{{ t('compte.subscription.prioritySupport') }}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            }
        </div>
        } @else {
        <!-- Affichage des plans disponibles -->
        @if (isLoadingPlans()) {
        <div class="flex justify-center items-center py-12">
            <svg class="animate-spin h-8 w-8 text-[#ff5c01]" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                </path>
            </svg>
        </div>
        } @else {
        <!-- Sélecteur de période -->
        <div class="flex items-center justify-center gap-4 mb-8">
            <!-- Label Mensuel -->
            <span class="text-sm font-medium text-gray-700" [class.text-gray-900]="!isYearlyBilling()">
                {{ t('compte.subscription.monthly') }}
            </span>

            <!-- TOGGLE SIMPLIFIÉ AVEC SLIDER -->
            <button type="button" (click)="toggleBillingPeriod()"
                class="relative w-14 h-7 rounded-full transition-colors duration-300"
                [ngClass]="isYearlyBilling() ? 'bg-orange-500' : 'bg-gray-200'">
                <div class="absolute top-1 left-1 w-5 h-5 bg-white rounded-full shadow transition-transform duration-300"
                    [class.translate-x-7]="isYearlyBilling()">
                </div>
            </button>

            <!-- Label Annuel + Remise -->
            <span class="text-sm font-medium text-gray-700 flex items-center gap-2"
                [class.text-gray-900]="isYearlyBilling()">
                {{ t('compte.subscription.yearly') }}
                @if (basicPlan() && basicPlan()!.yearlyDiscountRate > 0) {
                <span class="px-2 py-0.5 bg-orange-100 text-orange-600 text-xs font-semibold rounded">
                    {{ t('compte.subscription.save', {percent: basicPlan()!.yearlyDiscountRate}) }}
                </span>
                }
            </span>
        </div>

        <!-- Cartes d'abonnement -->
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-4xl mx-auto">
            <!-- Carte Basic -->
            @if (basicPlan()) {
            <div class="relative border-2 border-[#ff5c01] bg-white rounded-2xl shadow-lg overflow-hidden">
                <div class="p-8">
                    <div class="text-center mb-6">
                        <h3 class="text-2xl font-bold text-gray-900 mb-2">
                            {{ getPlanLabel(basicPlan()!) }}
                        </h3>
                        <div class="flex items-baseline justify-center gap-1 mb-4">
                            <span class="text-3xl font-bold text-gray-900">
                                {{ formatPrice(basicPlan()!) }}
                            </span>
                            <span class="text-gray-600">FCFA</span>
                            <span class="text-gray-500 text-sm">/ {{ isYearlyBilling() ?
                                t('compte.subscription.perMonthYearly') :
                                t('compte.subscription.perMonth') }}</span>
                        </div>

                        @if (isYearlyBilling() && basicPlan()!.yearlyDiscountRate > 0) {
                        <div class="text-sm text-gray-500">
                            <span class="line-through">{{ (basicPlan()!.totalCost * 12).toLocaleString('fr-FR') }} FCFA/an</span>
                            <span class="ml-2 text-green-600 font-semibold">
                                {{ t('compte.subscription.save', {percent: basicPlan()!.yearlyDiscountRate}) }}
                            </span>
                        </div>
                        }
                    </div>

                    <div class="mb-6">
                        <p class="text-gray-700 text-sm text-center">
                            {{ getPlanDescription(basicPlan()!) }}
                        </p>
                    </div>

                    <ul class="space-y-4 mb-8">
                        <li class="flex items-start gap-3">
                            <svg class="w-5 h-5 text-green-500 mt-0.5 flex-shrink-0" fill="none"
                                stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round"
                                    stroke-width="2" d="M5 13l4 4L19 7"></path>
                            </svg>
                            <span class="text-gray-700">
                                @if (basicPlan()!.unlimitedProjects) {
                                {{ t('compte.subscription.unlimitedProjects') }}
                                } @else {
                                {{ t('compte.subscription.maxProjects', {limit: basicPlan()!.projectLimit}) }}
                                }
                            </span>
                        </li>
                        <li class="flex items-start gap-3">
                            <svg class="w-5 h-5 text-green-500 mt-0.5 flex-shrink-0" fill="none"
                                stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round"
                                    stroke-width="2" d="M5 13l4 4L19 7"></path>
                            </svg>
                            <span class="text-gray-700">
                                Paiement en {{ basicPlan()!.installmentCount }} fois
                            </span>
                        </li>
                        @if (basicPlan()!.yearlyDiscountRate > 0) {
                        <li class="flex items-start gap-3">
                            <svg class="w-5 h-5 text-green-500 mt-0.5 flex-shrink-0" fill="none"
                                stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round"
                                    stroke-width="2" d="M5 13l4 4L19 7"></path>
                            </svg>
                            <span class="text-gray-700">
                                {{ t('compte.subscription.save', {percent: basicPlan()!.yearlyDiscountRate}) }}
                            </span>
                        </li>
                        }
                    </ul>

                    <button (click)="subscribeToPlan('Basic')" [disabled]="isProcessingBasic()"
                        [class.opacity-50]="isProcessingBasic()"
                        [class.cursor-not-allowed]="isProcessingBasic()"
                        class="w-full py-3 border-2 border-[#ff5c01] text-[#ff5c01] font-semibold rounded-full hover:bg-[#ff5c01] hover:text-white transition-colors flex items-center justify-center gap-2">
                        @if (isProcessingBasic()) {
                        <svg class="animate-spin h-5 w-5" fill="none" viewBox="0 0 24 24">
                            <circle class="opacity-25" cx="12" cy="12" r="10"
                                stroke="currentColor" stroke-width="4"></circle>
                            <path class="opacity-75" fill="currentColor"
                                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                            </path>
                        </svg>
                        <span>{{ t('compte.subscription.processing') }}</span>
                        } @else {
                        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                stroke-width="2"
                                d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z">
                            </path>
                        </svg>
                        <span>{{ t('compte.subscription.subscribe') }}</span>
                        }
                    </button>
                </div>
            </div>
            } @else {
            <div class="flex items-center justify-center p-8 bg-gray-50 rounded-2xl">
                <p class="text-gray-500">Plan Basic non disponible</p>
            </div>
            }

            <!-- Carte Premium -->
            @if (premiumPlan()) {
            <div class="relative bg-gradient-to-br shadow rounded-2xl shadow-lg overflow-hidden">
                <div class="absolute top-4 right-4 bg-[#ff5c01] text-white text-xs font-bold px-3 py-1 rounded-full">
                    POPULAIRE
                </div>

                <div class="p-8">
                    <div class="text-center mb-6">
                        <h3 class="text-2xl font-bold mb-2">
                            {{ getPlanLabel(premiumPlan()!) }}
                        </h3>
                        <div class="flex items-baseline justify-center gap-1 mb-4">
                            <span class="text-3xl font-bold">
                                {{ formatPrice(premiumPlan()!) }}
                            </span>
                            <span class="">FCFA</span>
                            <span class=" text-sm">/ {{ isYearlyBilling() ? 'mois (annuel)' : 'mois' }}</span>
                        </div>

                        @if (isYearlyBilling() && premiumPlan()!.yearlyDiscountRate > 0) {
                        <div class="text-sm ">
                            <span class="line-through">{{ (premiumPlan()!.totalCost * 12).toLocaleString('fr-FR') }} FCFA/an</span>
                            <span class="ml-2  font-semibold">
                                Économisez {{ premiumPlan()!.yearlyDiscountRate }}%
                            </span>
                        </div>
                        }
                    </div>

                    <div class="mb-6">
                        <p class=" text-sm text-center">
                            {{ getPlanDescription(premiumPlan()!) }}
                        </p>
                    </div>

                    <ul class="space-y-4 mb-8">
                        <li class="flex items-start gap-3">
                            <svg class="w-5 h-5  mt-0.5 flex-shrink-0" fill="none"
                                stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round"
                                    stroke-width="2" d="M5 13l4 4L19 7"></path>
                            </svg>
                            <span class="text-black">
                                @if (premiumPlan()!.unlimitedProjects) {
                                Projets illimités
                                } @else {
                                {{ premiumPlan()!.projectLimit }} projet{{ premiumPlan()!.projectLimit > 1 ? 's' : '' }} maximum
                                }
                            </span>
                        </li>
                        <li class="flex items-start gap-3">
                            <svg class="w-5 h-5  mt-0.5 flex-shrink-0" fill="none"
                                stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round"
                                    stroke-width="2" d="M5 13l4 4L19 7"></path>
                            </svg>
                            <span class="">
                                Paiement en {{ premiumPlan()!.installmentCount }} fois
                            </span>
                        </li>
                        @if (premiumPlan()!.yearlyDiscountRate > 0) {
                        <li class="flex items-start gap-3">
                            <svg class="w-5 h-5  mt-0.5 flex-shrink-0" fill="none"
                                stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round"
                                    stroke-width="2" d="M5 13l4 4L19 7"></path>
                            </svg>
                            <span class="">
                                {{ premiumPlan()!.yearlyDiscountRate }}% de réduction en paiement annuel
                            </span>
                        </li>
                        }
                    </ul>

                    <button (click)="subscribeToPlan('Premium')"
                        [disabled]="isProcessingPremium()"
                        [class.opacity-50]="isProcessingPremium()"
                        [class.cursor-not-allowed]="isProcessingPremium()"
                        class="w-full py-3 bg-[#ff5c01] text-white font-semibold rounded-full transition-colors flex items-center justify-center gap-2">
                        @if (isProcessingPremium()) {
                        <svg class="animate-spin h-5 w-5" fill="none" viewBox="0 0 24 24">
                            <circle class="opacity-25" cx="12" cy="12" r="10"
                                stroke="currentColor" stroke-width="4"></circle>
                            <path class="opacity-75" fill="currentColor"
                                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                            </path>
                        </svg>
                        <span>Traitement...</span>
                        } @else {
                        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                stroke-width="2"
                                d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z">
                            </path>
                        </svg>
                        <span>Passer à Premium</span>
                        }
                    </button>
                </div>
            </div>
            } @else {
            <div class="flex items-center justify-center p-8 bg-gray-50 rounded-2xl">
                <p class="text-gray-500">Plan Premium non disponible</p>
            </div>
            }
        </div>
        }
        }
    }
</div>
}

                            @if (activeTab() === 'factures') {
                            <!-- Contenu Factures -->
                            <!-- Barre de recherche et filtre -->
                            <div class="flex flex-col sm:flex-row gap-4 mb-6">
                                <div class="flex-1 relative">
                                    <svg class="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400"
                                        fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
                                    </svg>
                                    <input type="text" [placeholder]="t('compte.invoices.searchPlaceholder')"
                                        class="w-full pl-10 pr-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#ff5c01] focus:border-transparent" />
                                </div>
                                <select
                                    class="px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#ff5c01] focus:border-transparent bg-white">
                                    <option value="all">{{ t('compte.invoices.allStatus') }}</option>
                                    <option value="Actif">{{ t('compte.invoices.active') }}</option>
                                    <option value="Expiré">{{ t('compte.invoices.expired') }}</option>
                                </select>
                            </div>
                            <div>
                                @if (isLoadingFactures()) {
                                <div class="flex justify-center py-12">
                                    <svg class="animate-spin h-10 w-10 text-[#ff5c01]" fill="none"
                                        viewBox="0 0 24 24">...</svg>
                                </div>
                                } @else {
                                <div class="bg-gray-50 rounded-lg overflow-hidden">
                                    <table class="w-full">
                                        <thead class="bg-gray-100">
                                            <tr>
                                                <th
                                                    class="px-6 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">
                                                    {{ t('compte.invoices.reference') }}</th>
                                                <th
                                                    class="px-6 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">
                                                    {{ t('common.date') }}</th>
                                                <th
                                                    class="px-6 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">
                                                    {{ t('compte.invoices.amount') }}</th>
                                                <th
                                                    class="px-6 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">
                                                    {{ t('compte.invoices.plan') }}</th>
                                                <th
                                                    class="px-6 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">
                                                    {{ t('compte.invoices.status') }}</th>
                                                <th
                                                    class="px-6 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">
                                                    {{ t('common.actions') }}</th>
                                            </tr>
                                        </thead>
                                        <tbody class="bg-white divide-y divide-gray-200">
                                            @for (facture of factures(); track facture.id) {
                                            <tr class="hover:bg-gray-50">
                                                <td class="px-6 py-4 text-sm font-medium text-gray-900">{{
                                                    facture.invoiceNumber }}</td>
                                                <td class="px-6 py-4 text-sm text-gray-600">{{
                                                    formatDate(facture.createdAt)
                                                    }}</td>
                                                <td class="px-6 py-4 text-sm font-medium text-gray-900">{{
                                                    formatMontant(facture.amount) }}</td>
                                                <td class="px-6 py-4 text-sm text-gray-600">{{ facture.planLabel }}</td>
                                                <td class="px-6 py-4">
                                                    @if (facture.paid) {
                                                    <span
                                                        class="px-3 py-1 rounded-full text-xs font-medium bg-green-100 text-green-700">{{
                                                        t('common.paid') }}</span>
                                                    } @else {
                                                    <span
                                                        class="px-3 py-1 rounded-full text-xs font-medium bg-yellow-100 text-yellow-700">{{
                                                        t('compte.invoices.pending') }}</span>
                                                    }
                                                </td>
                                                <td class="px-6 py-4 text-sm">
                                                    @if (facture.paid) {
                                                    <button (click)="telechargerFacturePDF(facture)"
                                                        class="inline-flex items-center gap-2 text-[#ff5c01] hover:text-[#e54f00] font-medium transition-colors duration-200">

                                                        <svg class="w-5 h-5" fill="none" stroke="currentColor"
                                                            viewBox="0 0 24 24">
                                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                                stroke-width="2"
                                                                d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z">
                                                            </path>
                                                        </svg>


                                                    </button>
                                                    } @else {
                                                    <button (click)="payerFacture(facture.id.toString())"
                                                        class="text-white bg-green-600 hover:bg-green-700 px-4 py-2 rounded-lg text-sm font-medium">
                                                        {{ t('compte.invoices.payNow') }}
                                                    </button>
                                                    }
                                                </td>

                                            </tr>
                                            } @empty {
                                            <tr>
                                                <td colspan="6" class="text-center py-12 text-gray-500">{{
                                                    t('compte.invoices.noInvoices') }}</td>
                                            </tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>

                                <!-- Pagination -->
                                <!-- ... inchangé ... -->
                                }
                            </div>
                            }
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
    </div>